var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPromotion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.373,
    height: 16.373,
    viewBox: "0 0 16.373 16.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL1_wght400_GRAD0_opsz24",
    d: "M120-823.627v-3.866l12.007-11.984a2.043,2.043,0,0,1,.6-.387A1.8,1.8,0,0,1,133.3-840a1.881,1.881,0,0,1,.7.136,1.6,1.6,0,0,1,.591.409l1.251,1.273a1.487,1.487,0,0,1,.4.591,1.97,1.97,0,0,1,.125.682,1.938,1.938,0,0,1-.125.694,1.7,1.7,0,0,1-.4.6l-11.984,11.984Zm13.281-12.007,1.273-1.273-1.273-1.273-1.273,1.273Z",
    transform: "translate(-120 840)",
    fill: "#ff8c2e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPromotion);
export default __webpack_public_path__ + "static/media/edit-promotion.abd97176a24768e1d016bfbbacb7e003.svg";
export { ForwardRef as ReactComponent };